// src/utils/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Only initialize Firebase app and services, no auth required

const firebaseConfig = {
  apiKey: "AIzaSyBK76yZlUXBkR1M5JbfEPKrZwtFgWsLYqU",
  authDomain: "legal-landonmayo.firebaseapp.com",
  projectId: "legal-landonmayo",
  storageBucket: "legal-landonmayo.firebasestorage.app", // fixed typo here
  messagingSenderId: "257655261084",
  appId: "1:257655261084:web:3b4eeae0e5a4383992aa59",
  measurementId: "G-HTNK4BZ7SN"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, db, storage };
